import { useSelector } from 'react-redux';
import { getItemsForBreadcrumbs } from './getItemsForBreadcrumbs';
import { Breadcrumb } from '@designsystem/stories/03-molecules/Breadcrumb';
import { normalizeLink } from '@fhnw/helpers/DesignSystem/normalizeContent';

type GlobalBreadcrumbsProps = {
  closeGlobalSearch: () => void;
  item: any;
};
const GlobalSearchBreadcrumbs = ({
  closeGlobalSearch,
  item,
}: GlobalBreadcrumbsProps) => {
  const breadcrumbs = item ? item['@id'].split('/') : [];

  const navroot = useSelector(
    (state: any) => state.content?.data?.['@components']?.navroot,
  );
  const navigation_with_excluded = useSelector(
    (state: any) => state.navigation_with_excluded,
  );

  const breadcrumbItems = getItemsForBreadcrumbs(
    navroot,
    navigation_with_excluded,
    breadcrumbs,
  );

  if (breadcrumbItems.length === 0) return null;

  return (
    <Breadcrumb
      className="card__breadcrumbs"
      primary={{
        label: breadcrumbItems[breadcrumbItems.length - 1].title,
        href: normalizeLink(breadcrumbItems[breadcrumbItems.length - 1]),
        onClick: closeGlobalSearch,
      }}
      items={breadcrumbItems.map((item) => ({
        label: item.title,
        href: normalizeLink(item),
        onClick: closeGlobalSearch,
      }))}
    />
  );
};

export default GlobalSearchBreadcrumbs;
